export function nextPage(page) {
  return {
    type: '@page/NEXT_PAGE',
    payload: page
  };
}